import FullWidthLayout from "@/layouts/FullWidthLayout";
import DeliveryNotesReport from "kinnect-front/KYard/Reports/DeliveryNotes/Report";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardDeliveryNotesReportPage",

	metaInfo: { title: "Yard - Delivery Notes Report" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<DeliveryNotesReport></DeliveryNotesReport>
		</FullWidthLayout>;
	}
};
